module.exports = __webpack_public_path__ + "static/media/discount-no-source.5641c1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/discount-no-source.png
// module id = 1972
// module chunks = 6